var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BaseComponent, BaseComponentPlus } from "react-vextensions";
import { PanelHeader } from "UI/Write/MapUI/Panel";
import { Column, Button, Row } from "react-vcomponents";
import { Observer } from "vwebapp-framework";
import { store } from "Store";
import { E } from "js-vextensions";
import { runInAction } from "mobx";
let ToolboxPanel = class ToolboxPanel extends BaseComponentPlus({}, {}) {
    render() {
        const selectedTool = store.main.write.selectedTool;
        //<Icon icon="arrow-right" size={15}/>
        return (React.createElement(Column, null,
            React.createElement(PanelHeader, { text: "Toolbox" }),
            React.createElement(Column, null,
                React.createElement(Row, null,
                    React.createElement(ToolSelectButton, { tool: "SelectObject", selected: selectedTool == "SelectObject", text: "Select" }),
                    React.createElement(ToolSelectButton, { tool: "AddObject", selected: selectedTool == "AddObject", text: "Add" }),
                    React.createElement(ToolSelectButton, { tool: "EditPoints", selected: selectedTool == "EditPoints", text: "Edit points" })))));
    }
};
ToolboxPanel = __decorate([
    Observer
], ToolboxPanel);
export { ToolboxPanel };
class ToolSelectButton extends BaseComponent {
    render() {
        const { tool, selected, text, title } = this.props;
        return (React.createElement(Button, { text: text || tool, title: title, style: E(selected && { backgroundColor: "rgba(90,100,110,.8)" }), onClick: () => {
                //SetCurrentMapTool(tool);
                runInAction("ToolSelectButton.onClick", () => store.main.write.selectedTool = tool);
            } }));
    }
}
